import React from "react"
import StarIcon from "material-ui/svg-icons/toggle/star"
import { EExceptionUITypes } from "../../models"
import CircularProgress from 'material-ui/CircularProgress';
const styles = {
  collapsedItem: {
    width: 100,
    height: "100%",
    textAlign: "center",
    lineHeight: "13px",
    cursor: "pointer"
  },
  collapsedSelectedItem: {
    border: "2px solid rgb(255, 196, 0)",
    width: 96,
    height: 76,
    textAlign: "center",
    lineHeight: "13px",
    backgroundColor: "#F5F5F5",
    position: "relative" as "relative",
    cursor: "pointer"
  },
  collapsedHour: {
    height: 25,
    paddingTop: 20,
    fontSize: 25,
    fontWeight: "bold" as "bold"
  },
  collapsedItemType: {
    fontSize: 11,
    color: "rgba(0, 0, 0, 0.5)"
  }
}
interface IProps {
  type: EExceptionUITypes
  count: number
  topTitle: string
  bottomTitle: string
  selected: boolean
  handleSelect(type: EExceptionUITypes): void
}

const ExceptionFilterItem: React.SFC<IProps> = (props: IProps) => {
  return (
    <div style={{ height: 80, width: 100, paddingLeft: 5, paddingRight: 5 }}>
      <div
        data-intercom-target={`ExceptionFilter-${props.topTitle}`}
        style={props.selected ? styles.collapsedSelectedItem : styles.collapsedItem}
        onClick={() => props.handleSelect(props.type)}
      >
        {props.selected &&
          <StarIcon style={{ width: 20, height: 20, position: "absolute", top: 2, left: 5 }} />
        }
        <div style={styles.collapsedHour}>
          {props.count === null ? <CircularProgress size={20} /> : <span>{props.count}</span>}
        </div>
        <div style={styles.collapsedItemType} title={`${props.topTitle} ${props.bottomTitle}`}>
          <div className="TextOverflow">{props.topTitle}</div>
          <div className="TextOverflow">{props.bottomTitle}</div>
        </div>
      </div>
    </div>
  )
}

export default ExceptionFilterItem